export default __webpack_public_path__ + "static/media/desktop-feature.565ecd08.png";